import Vue from "vue";
import Vuex from "vuex";
// import QRCode from 'qrcode'

Vue.use(Vuex);

const defaultUserInfo = {
    id: null,
    login: null,
    password: null,
    user_code: null,
    email: null,
    api_token: null
};
const store = new Vuex.Store({
    state: {
        userInfo: {
            id: null,
            login: null,
            password: null,
            user_code: null,
            email: null,
            api_token: null
        },
        dialog: {
            show: false,
            text: "",
            icon: "",
            iconColor: "",
            closeEvent: null,
            content: "",
            multiLine: false,
            multiLineTexts: []
        },
        saveDialog: {
            show: false,
            text: "",
            icon: "",
            iconColor: "",
            closeEvent: null,
            content: "",
            multiLine: false,
            multiLineTexts: []
        },
        agreeDialog: {
            show: false,
            title: "",
            contentText: "",
            agreeBtnText: "",
            agreeBtnEvent: null,
            dissAgreeBtnText: "",
            dissAgreeBtnEvent: null,
        },
        issueDialog: {
            show: false,
            title: "",
            description: "",
            urlList: [],
            closeEvent: null,
            issueNewUrl: null,
            issueUrlPlus: null,
        },
        planDialog: {
            show: false,
            closeEvent: null,
        },
        watchTitle: "",
        loading: false,
    },
    mutations: {
        SHOW_Dialog(state, dialog) {
            state.dialog = {
                show: true,
                ...dialog
            };
        },
        SAVE_DIALOG(state, dialog) {
            state.saveDialog = {
                show: true,
                ...dialog
            };
        },
        SHOW_AGREE_DIALOG(state, dialog) {
            state.agreeDialog = {
                show: true,
                ...dialog
            };
        },

        SHOW_PLAN_DIALOG(state, dialog) {
            state.planDialog = {
                show: true,
                ...dialog
            };
        },

        // SET_ISSUE_URL(state, urlData) {
        //   QRCode.toDataURL(urlData.url).then(code => {
        //     urlData.qrCodeImg = code;
        //     state.issueDialog.urlList.push(urlData);
        //   });
        // },
        SET_USERINFO(state, userInfo) {
            state.userInfo = {
                ...defaultUserInfo,
                ...userInfo,
            };
        },

        SET_LOADING(state, loading) {
            state.loading = loading;
        }
    },
    actions: {},
    getters: {
        userInfo: state => state.userInfo,
        dialog: state => state.dialog,
        saveDialog: state => state.saveDialog,
        agreeDialog: state => state.agreeDialog,
        issueDialog: state => state.issueDialog,
        watchTitle: state => state.watchTitle,
        getLoading: state => state.loading,
        planDialog: state => state.planDialog
    }
});

export default store;
